import React from "react";
import { Container, Typography } from "@mui/material";
import Header from "../Components/header/Header"; // 引入 Header 组件
import Footer from "../Components/footer/Footer"; // 引入 Footer 组件
import WhyChooseUs from "../Components/WhyChooseUs";
import BestSellingProduct from "../Components/BestSellingProduct";
import ExperiencesAndMaterials from "../Components/ExperiencesAndMaterials";

const Home = () => {
  return (
    <div style={{ overflowX: "hidden", position: "relative", minHeight: "100vh" }}>
      {/* Header + Banner 作为一个整体 */}
      <div
        style={{
          position: "relative",
          minHeight: "100vh", // 占满整个视口高度
          backgroundImage: `
            linear-gradient(to bottom, rgba(255, 255, 255, 0) 80%, rgba(255, 255, 255, 1) 100%),
            url('/images/homepageImage4.jpg')`,
          backgroundSize: "cover", // 背景图片覆盖整个容器
          backgroundPosition: "center", // 图片居中
          backgroundRepeat: "no-repeat", // 不重复背景
        }}
      >
        {/* Header 放在背景容器内 */}
        <Header
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: 10, // 确保 Header 在最上层
          }}
        />

        {/* Banner 内容部分 */}
        <Container
          maxWidth="md"
          sx={{
            height: "100vh", // 占满整个视口高度
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            sx={{ fontWeight: "bold", color: "white" }}
          >
            Elevate Your Space with Premium Materials from Spring Creek
          </Typography>

          <Typography
            variant="body1"
            color="textSecondary"
            gutterBottom
            sx={{ color: "white", maxWidth: "80%" }}
          >
            At Spring Creek, we understand the value of using high-quality materials
            to create interiors that reflect elegance and durability. Whether it’s 
            Melamine, PET, or Thermofoil, our materials ensure the finest finish.
          </Typography>
        </Container>
      </div>

      {/* 其他内容部分 */}
      <WhyChooseUs />
      <BestSellingProduct />
      <ExperiencesAndMaterials />

      {/* Footer 部分 */}
      <Footer />
    </div>
  );
};

export default Home;